import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vueX';

import main from '@/components/main'
import home from '@/components/home/home'  //首页
import commercialLawColumn from '@/components/common/commercialLawColumn'  //商事法律专栏
import lawColumnInfo from '@/components/common/lawColumnInfo'  //商事法律专栏详情

import post from '@/components/post'  //知识详情、

import lawyer from '@/components/lawyer/lawyer'  //商事律师

import legalConsult from '@/components/legalConsult/legalConsult'  //企业法律咨询

import legalCourse from '@/components/legalCourse/legalCourse'  //企业法务通
import moreCourse from '@/components/legalCourse/moreCourse'  //更多课程
import courseInfo from '@/components/legalCourse/courseInfo'  //课程详情

import legalDepartment from '@/components/legalDepartment/legalDepartment'  //企业法务部

import help from '@/components/help/help'  //帮助中心

import personalSetter from '@/components/personalSetter';  //账号设置
import accountSet from '@/components/personalSetter/accountSet';  //个人设置
import mybill from '@/components/personalSetter/mybill';  //我的账户
import payList from '@/components/personalSetter/paylist';  //付费专栏

import agreement from '@/components/agreement/agreement'; //用户协议
import userAgreement from '@/components/agreement/userAgreement'; //用户协议
import payAgreement from '@/components/agreement/payAgreement'; //支付协议

import search from '@/components/search';  //全局搜索

import personalPage from '@/components/personalpage';  //个人主页
import personalCenter from '@/components/personalpage/personalCenter';  //个人主页详情

import news from '@/components/notice/news';  //通知消息列表页

//资讯聊天框
import chats from '@/components/consult'  //用户资讯
import lawyerChat from '@/components/consult/lawyerChat'  //律师咨询
//客服管理
import customer from '@/components/consult/customer'
import accountManage from '@/components/consult/customer/accountManage'  //账号管理
import consultSession from '@/components/consult/customer/consultSession'  //咨询会话
import customerRecord from '@/components/consult/customer/customerRecord'  //客户记录

import companyProfile from '@/components/aboutHonsen/companyProfile'  //公司介绍
import joinUs from '@/components/aboutHonsen/joinUs'  //加入我们
import dynamicInformation from '@/components/aboutHonsen/dynamicInformation'  //动态资讯

import notFound from '@/components/notFound';  //未定位页面

Vue.use(Router)

let router = new Router({
	  mode: 'history',
	  scrollBehavior(to, from, savedPosition) {
	    return { x: 0, y: 0 };
	  },
	  routes: [
	  	{
	  		path:'/',
	  		redirect: to => {
	        return {name: 'home'}
	      }
	  	},
	  	{
	      path:'/chats',
	      name:'chats',
	      component:chats,
	      meta:{
	          title:'法律咨询'
	      }
	    },
	    {
	      path:'/lawyerChat',
	      name:'lawyerChat',
	      component:lawyerChat,
	      meta:{
	          title:'法律咨询--律师'
	      }
	    },
	    {
	      path:'/customer',
	      name:'customer',
	      component: customer,
	      meta: {
	        requireAuth: true,
	        title:'法律咨询--客服'
	      },
	      redirect: to => {
	        return { name: 'consultSession'}
	      },
	      children:[
	        {
	          path:'/customerRecord',
	          name:'customerRecord',
	          component:customerRecord,
	          meta:{
	              title:'法律咨询--账号管理'
	          }
	        },
	        {
	          path:'/consultSession',
	          name:'consultSession',
	          component:consultSession,
	          meta:{
	              title:'法律咨询--客服'
	          }
	        },
	        {
	          path:'/accountManage',
	          name:'accountManage',
	          component:accountManage,
	          meta:{
	              title:'法律咨询--客户记录'
	          }
	        },
	      ]
	    },
	  	{
	  		path: '/',
		    name: 'Main',
		    component: main,
		    redirect:'/home',
		    children:[
		    	{
			      path: '/home',
			      name: 'home',
			      component: home
			    },
			    {
			      path: '/lawyer',
			      name: 'lawyer',
			      component: lawyer,
			      meta:{
			    		title:'商事律师-弘商法律云平台'
			      }
			    },
			    {
			      path: '/legalConsult',
			      name: 'legalConsult',
			      component: legalConsult,
			      meta:{
			    		title:'企业法律咨询-弘商法律云平台'
			    	}
			    },
			    {
			      path: '/legalCourse',
			      name: 'legalCourse',
			      component: legalCourse,
			      meta:{
			    		title:'企业法务通-弘商法律云平台'
			    	}
			    },
			    {
			      path: '/legalDepartment',
			      name: 'legalDepartment',
			      component: legalDepartment,
			      meta:{
			    		title:'企业法务部-弘商法律云平台'
			    	}
			    },
			    {
			      path: '/help',
			      name: 'help',
			      component: help,
			      meta:{
			    		title:'帮助中心-弘商法律云平台'
			    	}
			    },
			    {
			    	path:'/personalSetter',
			    	name:'personalSetter',
			    	component: personalSetter,
		            redirect: to => {
		                return { name: 'accountSet'}
		            },
		            children:[
		            	{
							path: 'accountSet',
							name: 'accountSet',
		                    component: accountSet,
		                    meta: {
		                        requireAuth: true,
		                        title:'个人设置-弘商法律云平台'
		                    }
						},
						{
		                    path: 'mybill',
		                    name: 'mybill',
		                    component: mybill,
		                    meta: {
		                        requireAuth: true,
		                        title:'我的账单-弘商法律云平台'
		                    }
		                },
		                {
		                    path: 'payList',
		                    name: 'payList',
		                    component: payList,
		                    meta: {
		                        requireAuth: true,
		                        title:'付费专栏-弘商法律云平台'
		                    }
		                },
		            ]
			    },
			    {
			    	path:'/commercialLawColumn',
			    	name:'commercialLawColumn',
			    	component:commercialLawColumn,
			    	meta:{
			    		title:'商事法律专栏-弘商法律云平台'
			    	}
			    },
			    {
		        	path:'/lawColumnInfo/:law_id',
		        	name:'lawColumnInfo',
		        	component:lawColumnInfo,
		        	meta: {
                        title:'商事法律专栏详情-弘商法律云平台'
                    }
		        },
			    {
		            path: '/agreement',
		            component: agreement,
		            redirect: to => {
		                return { name: 'userAgreement'}
		            },
		            children: [
		                {
		                    path: 'userAgreement',
		                    name: 'userAgreement',
		                    component: userAgreement
		                },
		                {
		                    path: 'payAgreement',
		                    name: 'payAgreement',
		                    component: payAgreement
		                }
		            ]
		        },
		        {
		        	path:'/search',
		        	name:'search',
		        	component:search,
		        },
		        {
		        	path:'/moreCourse',
		        	name:'moreCourse',
		        	component:moreCourse,
		        	meta: {
		        		title:'更多课程-弘商法律云平台'
		        	}
		        },
		        {
		        	path:'/course/:course_id',
		        	name:'courseInfo',
		        	component:courseInfo,
		        	meta: {
                        title:'课程详情-弘商法律云平台'
                    }
		        },
		        {
		        	path:'/post/:post_id',
		        	name:'post',
		        	component:post,
		        	meta: {
                        title:'知识详情-弘商法律云平台'
                    }
		        },
		        {
		          path: '/personalpage',
		          component: personalPage,
		          redirect: to => {
		              return { name: 'personalCenter'}
		          },
		          children: [
		            {
		              path: 'personalcenter/:id',
		              name: 'personalCenter',
		              component: personalCenter,
		              meta: {
		                title: '个人主页-弘商法律云平台'
		              }
		            }
		          ]
		        },
		        {
		            path: '/news',
		            name: 'news',
		            component: news,
		            meta: {
		                requireAuth: true,
		                title:'消息列表-弘商法律云平台'
		            }
		        },
		        {
		            path: '/companyProfile',
		            name: 'companyProfile',
		            component: companyProfile,
		            meta: {
		                title:'公司介绍-弘商法律云平台'
		            }
		        },
		        {
		            path: '/joinUs',
		            name: 'joinUs',
		            component: joinUs,
		            meta: {
		                title:'加入我们-弘商法律云平台'
		            }
		        },
		        {
		            path: '/dynamicInformation',
		            name: 'dynamicInformation',
		            component: dynamicInformation,
		            meta: {
		                title:'动态资讯-弘商法律云平台'
		            }
		        },
		        {
		          path: '*',
		          name: 'notFound',
		          component: notFound
		        },
		    ]
	  	}
	  ]
});

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

/* 路由拦截 */
router.beforeEach((to, from, next) => {
  if( store.state.loginStatus ) {     // 登录了逻辑
    next();
  }else{    // 没登录逻辑
    if( to.meta.requireAuth ) {     // 判断是否需要登录权限 没权限跳转去登录页
      next({
        name: 'home',
        query: { redirect: to.fullPath }
      });
    }else{
      next();
    }
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
    next();
  }else{
    document.title = '弘商法律云平台';
    next();
  }
  

});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js